<template>
<div id="container_app">
  <div class="locationWrap mypage">
    <div>
      <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
      <strong class="inner locTit aniBox type_bot gogo">
        <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>마이페이지
      </strong>
    </div>
  </div>
  <div class="contents">
    <div class="inner">
      <div class="subTitWrap aniBox type_left gogo">
        <h2>1:1 문의내역</h2>
      </div>

      <div class="qnaWrap">
        <form name="frm_search" @submit.prevent="loadData()">
        <div class="topSearchArea clearfix">
          <div class="topSearch clearfix">
            <select name="search_field" id="" class="select_ty1" v-model="searchOpt.keyType">
              <option value="01">전체</option>
              <option value="02">제목</option>
              <option value="03">내용</option>
            </select>
            <div class="inputBox">
              <input type="text" class="input_ty1" name="search_keyword" value="" v-model="searchOpt.keyWord" >
              <input type="button" class="btn_search" value="" @click="loadData()">
            </div>
          </div>
        </div>
        </form>

        <div class="bg_gray aniBox type_bot gogo dateSearch">
            <div style="display:inline">
            <datepicker input-class="datepicker" format="yyyy-MM-dd" :value="startDate" :language="ko" :disabled-dates="toDisabledDates" @selected="disableStartState"></datepicker>
            <datepicker input-class="datepicker" format="yyyy-MM-dd" :value="endDate" :language="ko" :disabled-dates="fromDisabledDates" @selected="disableEndState"></datepicker>
            </div>
            <!--
            <input type="text" class="datepicker" name="date" value="">
            <input type="text" class="datepicker" name="date" value="">
            -->
            <a href="javascript:" class="search" @click="loadData()">검색</a>
            <a href="javascript:" @click="setSearchOptDate(0, 'd')">오늘</a>
            <a href="javascript:" @click="setSearchOptDate(-15, 'd')">15일</a>
            <a href="javascript:" @click="setSearchOptDate(-1, 'M')">1개월</a>
            <a href="javascript:" @click="setSearchOptDate(-3, 'M')">3개월</a>
            <a href="javascript:" @click="setSearchOptDate(-6, 'M')">6개월</a>
            <router-link to="/support/qna" class="btn_question">1:1 문의하기</router-link>
        </div>

        <!-- toggleList -->
        <div class="count">전체 <span v-text="pageInfo.totalCount"></span> 건</div>
        <div class="myList">
          <dl class="type_right" v-for="listItem in gridData" v-bind:key="listItem.keyid">
            <dt>
              <strong class="tit" v-text="listItem.title"></strong>
              <p><span v-text="dateFmt(listItem.regDate)"></span> ｜ <span v-text="listItem.repContents?'답변완료':'답변대기'"></span></p>
            </dt>
            <dd style="display: none;">
              <div class="q_cont" v-html="stringReplace(listItem.contents)"></div>
              <div class="a_cont" v-html="listItem.repContents?listItem.repContents:'답변 대기중 입니다.'">
              </div>
            </dd>
          </dl>
          <!--
          <div class="btn_area taC type_bot btn_more" v-if="pageInfo.endPageNo===pageInfo.pageNo">
            <a href="javascript:" >더보기&nbsp;&nbsp;&nbsp;+</a>
          </div>
          -->
        </div>
        <!-- //toggleList -->
        <div class="searchNothing" v-if="gridData.length === 0">
          <img src="/static/images/contents/icon_info.png" alt="">
          <p>조회결과가 없습니다.</p>
        </div>
        <paginate
         v-model="pageNo" v-if="pageInfo.finalPageNo"
         :page-count="pageInfo.finalPageNo"
         :page-range="10"
         :click-handler="loadData"
         :prev-text="'〈'"
         :prev-link-class="'first'"
         :next-text="'〉'"
         :next-class="'last'"
         :page-link-class="''"
         :first-last-button="'true'"
         first-button-text="〈〈"
         last-button-text="〉〉"
         :container-class="'paging'">
        </paginate>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import $ from 'jquery'
import VuejsPaginate from 'vuejs-paginate'
import Datepicker from 'vuejs-datepicker'
import {ko} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'MyQna',
  data () {
    return {
      gridData: [],
      pageInfo: [],
      pageNo: 1,
      countPerPage: 10,
      searchOpt: {
        keyWord: '',
        keyType: '01'
      },
      startDate: moment().add(-1, 'W').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      ko: ko,
      fromDisabledDates: {
        to: moment().add(-1, 'W').toDate()
      },
      toDisabledDates: {
        from: moment().toDate()
      }
    }
  },
  components: {
    'paginate': VuejsPaginate,
    Datepicker
  },
  methods: {
    stringReplace (contents) {
      return contents.replace(/(?:\r\n|\r|\n)/g,"</br>")
    },
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    loadData (no) {
      var _this = this
      var pageNo = no || 1
      var params = {
        pageNo: pageNo,
        keyWord: _this.searchOpt.keyWord,
        keyType: _this.searchOpt.keyType,
        startDate: _this.startDate,
        endDate: _this.endDate,
        countPerPage: _this.countPerPage
      }
      axios.get('/web/api/board/my/QNA', {withCredentials: true, params: params})
        .then(response => {
          if (response.data.result) {
            this.gridData = response.data.result
          } else {
            this.gridData = []
          }
          this.pageInfo = response.data.page
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    setSearchOptDate: function (d, o) {
      var _this = this
      _this.startDate = moment().add(d, o).format('YYYY-MM-DD')
      _this.endDate = moment().format('YYYY-MM-DD')
    },
    disableStartState: function (s) {
      var _this = this
      _this.startDate = moment(s).format('YYYY-MM-DD')
      _this.fromDisabledDates.to = s
    },
    disableEndState: function (s) {
      var _this = this
      _this.endDate = moment(s).format('YYYY-MM-DD')
      _this.toDisabledDates.from = s
    }
  },
  created () {
    this.loadData(1)
  },
  updated () {
    this.$nextTick(function () {
      $('.myList dt').unbind('click')

      $('.myList dt').click(function () {
        if ($(this).hasClass('on')) {
          $(this).parent('dl').removeClass('on')
          $(this).removeClass('on')
          $(this).next('dd').slideUp(200)
        } else {
          $(this).parent('dl').addClass('on')
          $(this).addClass('on')
          $(this).next('dd').slideDown(250)
        }
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.paging {
  padding-top : 20px;
}
.vdp-datepicker {
  display: inline-block;
}
.vdp-datepicker__calendar {
  background-color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/MyQna.vue